import api from '../../../services/Api';
import { IAuditoriaPejotizacaoResultado } from '../interfaces/IAuditoriaPejotizacao';

export const AuditoriaPejotizacaoService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaPejotizacaoResultado> {
    const response = await api.get<IAuditoriaPejotizacaoResultado>('auditoria-pejotizacao/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoLegal: '',
        qsaDisponivel: false,
        mensagemQsa: '',
        fornecedoresRecorrentes: [],
        fornecedoresConciliados: [],
      }
    );
  },
};
